export default __webpack_public_path__ + "/dist/images/privacy-inactive.svg";